interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label: string;
}

/**
 * docs/DESIGN_SYSTEM.md §4.4 — the single most-used control in the app.
 * Always paired with a visible text label (the `label` prop here is for
 * aria-label; the visible label lives in ToggleRow, not this primitive).
 */
export function Toggle({ checked, onChange, disabled, label }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={[
        'relative inline-flex h-[22px] w-10 items-center rounded-full transition-colors shrink-0',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        checked ? 'bg-accent-management-500' : 'bg-bg-base border border-border-subtle',
      ].join(' ')}
    >
      <span
        className={[
          'inline-block h-[18px] w-[18px] transform rounded-full bg-white transition-transform',
          checked ? 'translate-x-[19px]' : 'translate-x-[2px]',
        ].join(' ')}
      />
    </button>
  );
}
